<template>
	<div class="search">
		<!-- Search icon -->
		<SearchIcon class="icon"></SearchIcon>

		<!-- Search input with bound value -->
		<input :value="value"
			ref="input"
			@input="changed"
			@focus="showResults"
			@blur="hideResults"
			type="text"
			placeholder="Search all patients">

		<div v-bind:class="['result', {
			active: searchActive
		}]" v-if="searchResultLength > 0">
			<div class="group">
				<p>patients</p>
				<ul>
					<li v-for="(patient, id) in searchResults" :key="id">
						<router-link :to="'/patient/' + id" @click="showPatient">
							{{ patient.name }}
						</router-link>
					</li>
				</ul>
			</div>
		</div>

		<!-- Arrow -->
		<SearchArrowIcon class="icon"></SearchArrowIcon>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

import Icons from '../icon/components'

export default {
	name: 'navbar-search',

	props: ['value'],

	data() {
		return {
			searchActive: false,
			searchResults: [], // TEMP
			searchResultLength: 0
		}
	},

	computed: {
		// ...mapGetters([
		// 	'filteredPatients'
		// ]),
		// searchResults() {
		// 	if (this.value.trim().length == 0)
		// 		return null
		// 	else
		// 		return this.filteredPatients(this.value)
		// },
		// searchResultLength() {
		// 	if (this.searchResults)
		// 		return Object.keys(this.searchResults).length
		// 	return 0
		// }
	},

	methods: {
		changed() {
			this.searchActive = true
			this.$emit('input', this.$refs.input.value)
		},
		showResults() {
			this.searchActive = true
		},
		showPatient(e) {
			e.stopPropagation()
			e.preventDefault()
			this.hideResults()
		},
		hideResults() {
			setTimeout(() => {
				this.searchActive = false
			}, 500)
		}
	},

	components: {
		...Icons
	}
}
</script>

<style lang="scss" scoped>
@import "../../style-config.scss";
@import "style.scss";
</style>
